import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Icons } from '@celebration/react/ClbIcon/props.types';
import Icon from '../../../icon';
import { IDrawerItemProps } from './Interfaces/IDrawerItemProps';
import { ISystem } from './Interfaces/INotificationsResponse';
import { SmartCargasNotificationType } from './Interfaces/INotificationType';

export default function DrawerItem({
    title,
    subtitle,
    date,
    isRead,
    actionLink,
    defaultAction,
    onTap,
    type,
    system,
}: Readonly<IDrawerItemProps>) {
    const { t } = useTranslation();

    const getNotificationIcon = (): Icons => {
        if (system === ISystem.SmartCargas) {
            switch (type) {
                case SmartCargasNotificationType.LoadConfirmed:
                    return 'check';
                case SmartCargasNotificationType.LoadCanceled:
                    return 'info';
                default:
                    return 'notification';
            }
        } else {
            return 'notification';
        }
    };

    return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <div className="content clickable-item" onClick={() => onTap()}>
            <div className="icon-container">
                <div
                    className={`Header__notifications ${
                        isRead ? '' : 'Header__notifications--new'
                    }
            custom_header_notification`}
                >
                    <div className="drawer-notification-icon">
                        <Icon size="md" icon={getNotificationIcon()} />
                    </div>
                </div>
            </div>
            <div className="text-container">
                <h4 className="item-title">{title}</h4>
                <div className="item-subtitle">{subtitle}</div>
            </div>
            <div className="date-action-container">
                <div className="date-container">
                    <p className="item-date">{date}</p>
                </div>
                <div className="action-link-container">
                    {actionLink && (
                        <Link
                            to={actionLink}
                            className="action-link"
                            onClick={() => defaultAction()}
                            data-testid="action-link"
                        >
                            {t('Visualizar')}
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
}
